import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Isotipo from "./Isotipo";
import { IMG, GATEWAY } from "@/data/site";
import { useLang } from "@/context/LanguageContext";

const Gateway = ({ onClose }) => {
  const { t, lp } = useLang();
  const navigate = useNavigate();
  const [hover, setHover] = useState(null);

  const choose = (path) => {
    try { sessionStorage.setItem("grabarte_entry", "1"); } catch (e) {}
    navigate(lp(path));
  };

  const flex = (side) => (!hover ? "lg:flex-[1]" : hover === side ? "lg:flex-[1.5]" : "lg:flex-[0.5]");

  const Panel = ({ side, img, accent, data, path, overlay, align }) => (
    <motion.button
      onMouseEnter={() => setHover(side)}
      onMouseLeave={() => setHover(null)}
      onClick={() => choose(path)}
      data-testid={`gateway-${side}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: side === "audiovisual" ? 0.1 : 0.2 }}
      className={`group relative overflow-hidden flex-1 min-h-[45vh] lg:min-h-0 transition-[flex] duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] ${flex(side)} ${align}`}
    >
      <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-[1200ms]" />
      <div className="absolute inset-0" style={{ background: overlay }} />
      <div className="relative z-10 h-full flex flex-col justify-center items-start text-left px-8 md:px-16 lg:px-20">
        <span className="font-display text-[0.7rem] md:text-xs font-bold uppercase tracking-[0.3em]" style={{ color: accent }}>
          {t(data.label)}
        </span>
        <h2 className="mt-4 font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "clamp(2.5rem, 6vw, 6rem)" }}>
          {t(data.line)}
        </h2>
        <p className="mt-5 max-w-sm text-white/70 font-body text-base md:text-lg">{t(data.sub)}</p>
        <span className="mt-8 inline-flex items-center gap-3 font-display text-xs md:text-sm font-bold uppercase tracking-[0.18em] text-white">
          {t({ es: "Entrar", en: "Enter" })}
          <span className="inline-block w-0 h-0 transition-transform duration-300 group-hover:translate-x-2" style={{ borderLeft: "8px solid", borderColor: accent, borderTop: "6px solid transparent", borderBottom: "6px solid transparent" }} />
        </span>
      </div>
    </motion.button>
  );

  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-ink flex flex-col lg:flex-row"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      data-testid="gateway"
    >
      <Panel
        side="audiovisual"
        img={IMG.filmmaker}
        accent="#edaa51"
        data={GATEWAY.audiovisual}
        path="/produccion-audiovisual"
        overlay="linear-gradient(120deg, rgba(23,23,38,0.55), rgba(23,23,38,0.92) 70%, rgba(237,170,81,0.2))"
        align="items-start"
      />
      <Panel
        side="marketing"
        img={IMG.analytics}
        accent="#3fbf97"
        data={GATEWAY.marketing}
        path="/marketing-comunicacion-eventos"
        overlay="linear-gradient(300deg, rgba(23,23,38,0.5), rgba(38,119,94,0.85) 75%)"
        align="items-start"
      />

      {/* center brand + skip */}
      <div className="absolute inset-x-0 top-8 z-20 flex flex-col items-center pointer-events-none">
        <div className="flex items-center gap-3">
          <Isotipo className="w-6 h-6" fill="#edaa51" />
          <span className="font-display text-lg font-black uppercase tracking-tight text-white">Grabarte</span>
        </div>
        <p className="mt-2 font-display text-[0.6rem] font-bold uppercase tracking-[0.35em] text-white/50">
          {t({ es: "Elige tu visión", en: "Choose your vision" })}
        </p>
      </div>

      <button
        onClick={() => { try { sessionStorage.setItem("grabarte_entry", "1"); } catch (e) {} onClose(); }}
        data-testid="gateway-skip"
        className="absolute inset-x-0 bottom-7 z-20 mx-auto w-max font-display text-[0.7rem] font-bold uppercase tracking-[0.25em] text-white/50 hover:text-white transition-colors"
      >
        {t({ es: "Ver la agencia completa →", en: "Explore the whole agency →" })}
      </button>
    </motion.div>
  );
};

export default Gateway;
